import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { article as articleData } from "shared/data/article";

import { getArticleType } from "scmp-app/components/article/article-render/helpers";
import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import type { highlightBlockItemContent$key } from "scmp-app/queries/__generated__/highlightBlockItemContent.graphql";

import {
  StyledContentItemPlusOpinion,
  StyledContentItemPlusPrimary,
  StyledContentItemPlusSecondary,
} from "./styles";

export type Props = {
  reference: highlightBlockItemContent$key;
};

export const HighlightBlockItem: FunctionComponent<Props> = ({ reference }) => {
  const content = useFragment(
    graphql`
      fragment highlightBlockItemContent on Content {
        entityId
        ...helpersGetArticleTypeArticle
        ...hooksPlusArticleLinkHandlerArticle
        ...plusOpinionContentItemContent
        ...plusPrimaryContentItemContent
        ...plusSecondaryContentItemContent
      }
    `,
    reference,
  );

  const { handleOpen } = usePlusArticlePopup();
  const articleTypeId = getArticleType(content) ?? "";

  switch (articleTypeId) {
    case articleData.types.betweenTheLines.entityId:
    case articleData.types.chinaFutureTechBriefing.entityId:
    case articleData.types.factSheet.entityId:
    case articleData.types.infographic.entityId:
      return (
        <StyledContentItemPlusPrimary
          onClick={() =>
            handleOpen(content, { pageType: "homepage", widgetName: "highlight_from_plus" })
          }
          reference={content}
        />
      );
    case articleData.types.column.entityId:
    case articleData.types.opinion.entityId:
      return (
        <StyledContentItemPlusOpinion
          onClick={() =>
            handleOpen(content, { pageType: "homepage", widgetName: "highlight_from_plus" })
          }
          reference={content}
          withAuthor
        />
      );
    default:
      return (
        <StyledContentItemPlusSecondary
          onClick={() =>
            handleOpen(content, { pageType: "homepage", widgetName: "highlight_from_plus" })
          }
          reference={content}
        />
      );
  }
};

HighlightBlockItem.displayName = "HighlightBlockItem";
